import { create } from 'zustand'

type State = {
  selectedFilters: Filters
}

export type Filters = { [key: string]: Array<string> }

type Action = {
  updateSelectedFilters: (selectedFilters: State['selectedFilters']) => void
}

export const useFilteredCardStore = create<State & Action>((set) => ({
  selectedFilters: {},
  updateSelectedFilters: (selectedFilters) =>
    set(() => ({ selectedFilters: selectedFilters })),
}))
